"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@mapmaker/ui");
const OrderLineItem_1 = __importDefault(require("./OrderLineItem"));
const client_1 = require("@apollo/client");
const client_2 = require("../../client");
(0, client_1.gql) `
  fragment MapLineItem on OrderItem {
    ... on MapLineItem {
      blueprintId
    }
  }
`;
function MapLineItem({ item }) {
    const { gotoFindMap } = (0, client_2.useMapmakerAppConfig)();
    return ((0, jsx_runtime_1.jsx)(OrderLineItem_1.default, Object.assign({}, item, { children: (0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ onClick: gotoFindMap, outlined: true, size: "small", style: { alignSelf: "end" } }, { children: "Create stickers for this Map" })) })));
}
exports.default = MapLineItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwTGluZUl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9vcmRlcnMvTWFwTGluZUl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHFDQUFrRDtBQUNsRCxvRUFBNEM7QUFDNUMsMkNBQXFDO0FBRXJDLHlDQUFvRDtBQUVwRCxJQUFBLFlBQUcsRUFBQTs7Ozs7O0NBTUYsQ0FBQztBQU1GLFNBQXdCLFdBQVcsQ0FBQyxFQUFFLElBQUksRUFBb0I7SUFDNUQsTUFBTSxFQUFFLFdBQVcsRUFBRSxHQUFHLElBQUEsNkJBQW9CLEdBQUUsQ0FBQztJQUMvQyxPQUFPLENBQ0wsdUJBQUMsdUJBQWEsb0JBQUssSUFBSSxjQUVyQix1QkFBQyxXQUFNLGtCQUNMLE9BQU8sRUFBRSxXQUFXLEVBQ3BCLFFBQVEsUUFDUixJQUFJLEVBQUMsT0FBTyxFQUNaLEtBQUssRUFBRSxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsa0RBR3BCLElBQ0ssQ0FDakIsQ0FBQztBQUNKLENBQUM7QUFmRCw4QkFlQyJ9